import { FivetranServiceEnum, fulfilSchema } from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

/** Setup form for the Fulfil Fivetran connector (API-key authentication). */
export const FulfilFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.fulfil,
    schema: fulfilSchema,
    defaultConfig: {
      schema: FivetranServiceEnum.enum.fulfil,
      api_key: "",
      workspace_id: "",
    },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="fulfil"
      submitLabel="Create"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />

      <form.AppField name="config.workspace_id">
        {(field) => (
          <field.TextField label="Workspace ID" placeholder="my-workspace" />
        )}
      </form.AppField>

      <form.AppField name="config.api_key">
        {(field) => (
          <field.PasswordField
            label="API Key"
            placeholder="XXXXXXXXXXXXXXXXXXXXXXXX"
          />
        )}
      </form.AppField>
    </ConnectionFormShell>
  );
};
